export default __webpack_public_path__ + "media/banner_mobile.53417d69.png";